import { lazy } from 'react';
export var TrackPageAsync = lazy(function () { return import('./TrackPage'); });
